// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Nn6M","footer":"ReportModalFilter_footer__2gSsQ"};